import React from 'react'
import styled from 'styled-components'

const ComponentError = styled.div`
  padding: 16px;

  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  font-size: 16px;

  color: #333;
  background-color: ${({ theme }) => theme.brand.afterglow};
`

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      errorInfo: null,
    }
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    })
  }

  render() {
    const { children } = this.props
    const { errorInfo, error } = this.state
    if (errorInfo) {
      return (
        <ComponentError>
          <h2>Error in this component tree.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {error && error.toString()}
            <br />
            {errorInfo.componentStack}
          </details>
        </ComponentError>
      )
    }
    // Normally, just render children
    return children
  }
}
